<!-- Under maintenance -->
<app-status-state headId="maintenance-head"
                  [logo]="BRAND.logo.maintenance"
                  [heroContents]="appHeroContents"
                  [informationType]="INFORMATION_TYPES.warning"
                  [links]="quickLinks"
                  (action)="redirect()"></app-status-state>
